module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('div', {
    staticClass: "search-wrapper"
  }, [_c('el-form', {
    attrs: {
      "inline": true
    },
    model: {
      value: (_vm.queryForm),
      callback: function($$v) {
        _vm.queryForm = $$v
      },
      expression: "queryForm"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.queryForm.type),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "type", $$v)
      },
      expression: "queryForm.type"
    }
  }, _vm._l((_vm.typeOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.queryForm.status),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "status", $$v)
      },
      expression: "queryForm.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "未发布",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已发布",
      "value": 2
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.queryList
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('div', {
    staticClass: "action-wrapper"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickAddition
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.listData
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "type": "index",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(_vm.handleType(row)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "名称",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "图形",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', {
          staticClass: "flex-row-center margin-bottom-10"
        }, [(row.pictures.length > 0) ? _c('img', {
          staticClass: "table-img",
          attrs: {
            "src": row.pictures[0].url,
            "alt": ""
          }
        }) : _vm._e(), _vm._v(" "), (row.pictures.length > 1) ? _c('img', {
          staticClass: "table-img",
          attrs: {
            "src": row.pictures[1].url,
            "alt": ""
          }
        }) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "文案"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n               " + _vm._s(row.copyWriter ? row.copyWriter.map(function (item) { return item.content; }).join(';') : '') + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "链接",
      "prop": "url"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "有效时间",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n               " + _vm._s(_vm.$util.dateFormat(new Date(row.startTime)) + ' - ' + _vm.$util.dateFormat(new Date(row.endTime))) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n               " + _vm._s(row.status == 2 ? '已发布' : '未发布') + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "最近操作时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n               " + _vm._s(_vm.$util.dateFormat(new Date(row.updateTime))) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "180",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.status == 2) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clickDetail(row)
            }
          }
        }, [_vm._v("详情")]) : _vm._e(), _vm._v(" "), (row.status == 1) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clickEdit(row)
            }
          }
        }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (row.status == 1) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clickPublish(row)
            }
          }
        }, [_vm._v("发布")]) : _vm._e(), _vm._v(" "), (row.status == 2) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clickRevoke(row)
            }
          }
        }, [_vm._v("撤销")]) : _vm._e(), _vm._v(" "), (row.status == 1) ? _c('el-button', {
          staticStyle: {
            "color": "red"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clickDelete(row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-wrapper"
  }, [_c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total > 0),
      expression: "total > 0"
    }],
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.queryForm.pageNum,
      "page-size": _vm.queryForm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.changeCurrentPage
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c78aaa72!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/AdvertisingSpace/PingAn/HomeConfiguration.vue
// module id = 1122
// module chunks = 0